'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'suitcase';
var width = 512;
var height = 512;
var aliases = [129523];
var unicode = 'f0f2';
var svgPathData = ['M32 160l0 256c0 17.7 14.3 32 32 32l32 0 0-320-32 0c-17.7 0-32 14.3-32 32zm96-32l0 320 256 0 0-320-16 0-224 0-16 0zm288 0l0 320 32 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-32 0z', 'M160 48l0 48 192 0 0-48c0-8.8-7.2-16-16-16L176 32c-8.8 0-16 7.2-16 16zM128 96l0-48c0-26.5 21.5-48 48-48L336 0c26.5 0 48 21.5 48 48l0 48 64 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l64 0zm240 32l-224 0-16 0 0 320 256 0 0-320-16 0zM64 128c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l32 0 0-320-32 0zM448 448c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-32 0 0 320 32 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSuitcase = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;